import React from 'react';

import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { CidAutoCompleteInput$, CidAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const renderSuggestion = (suggestion) => (
   <span>
      {suggestion.text}
   </span>
);
const CidAutoSuggest = renderAutoSuggestWithOptions(
   CidAutoCompleteObservable$,
   CidAutoCompleteInput$,
   renderSuggestion,
);

CidAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search contract name or input contract id...',
};

export default CidAutoSuggest;
